exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".auth-layout{height:100vh;margin:0}.auth-layout .main{margin:0;height:100%}.auth-layout .main .auth-content{padding:0;display:flex;align-items:center;justify-content:center;background-color:#fff}.auth-layout .main .auth-wallpaper{background-color:#333;overflow:hidden;display:flex;align-items:center;justify-content:center}.auth-layout .main .auth-wallpaper .basix-home{z-index:2;font-size:2.625rem;color:#1ec260}.auth-layout .main .auth-wallpaper .oblique{position:absolute;background-color:#282828;left:38.5%;transform:rotate(150deg);width:27%;height:115%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-74eaee2e","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/layouts/AuthLayout.vue
// module id = 562
// module chunks = 27